export { Pagination } from './Pagination';
export type { Props } from './Pagination.types';
